import _default from './oneLineTrim';
export { _default as default };
